import { useState, useEffect } from 'react';
import { isEmpty } from 'lodash';

import {
  Grid,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Checkbox,
  ListItemText
} from '@mui/material';

import { assignDocumentToAccountant, getOwnerUsers } from '../services/services';
import { Colors } from '../config/default';
import { docAssignment, userRoles } from '../constants/appConstants';
import { useToast } from '../toast/toastContext';
import Btn from './button';

const AssignDoc = ({ documentId, setOpen }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [accountantsList, setAccountantsList] = useState([]);
  const [docAssignees, setDocAssignees] = useState([]);
  const { showToast } = useToast();
  const { ASSIGN_DOC, SELECT_USERS } = docAssignment;
  const { ACCOUNTANT } = userRoles;

  const getUsers = async () => {
    const result = await getOwnerUsers();
    if (result?.status === 200) {
      const filteredUsers = result?.data?.payload?.data?.filter((item) => {
        return item?.role === ACCOUNTANT && item?.signUp === true;
      });
      const emails = filteredUsers?.map((item) => item?.email);
      setAccountantsList(emails);
    }
  };
  useEffect(() => {
    getUsers();
  }, []);

  const assignDocument = async () => {
    setIsLoading(true);
    const result = await assignDocumentToAccountant(documentId, docAssignees);
    if (result?.data?.metadata?.status === 'SUCCESS') {
      setOpen(false);
      setDocAssignees([]);
      setIsLoading(false);
      showToast(result?.data?.metadata?.message, 'success');
    } else {
      showToast(
        result?.data?.metadata?.message || result?.response?.data?.metadata?.message,
        'error'
      );
    }
  };

  const handleDocAssign = (event) => {
    setDocAssignees(event?.target?.value);
  };
  return (
    <Box sx={{ maxWidth: 550, margin: 'auto' }}>
      <Typography
        variant="h6"
        sx={{ color: Colors.WHITE, marginBottom: '1em', textAlign: 'center' }}>
        {ASSIGN_DOC}
      </Typography>
      <Grid
        container
        spacing={1}
        sx={{
          borderRadius: '10px',
          padding: '1em',
          width: '100%',
          marginLeft: '0px'
        }}>
        <FormControl
          fullWidth
          sx={{
            mt: 1,
            minWidth: '100%'
          }}>
          <InputLabel id="select-accountants-label" sx={{ fontSize: '16px' }}>
            {SELECT_USERS}
          </InputLabel>
          <Select
            labelId="select-accountants-label"
            id="select-accountants"
            multiple
            value={docAssignees}
            onChange={handleDocAssign}
            input={<OutlinedInput label="Select Accountants" />}
            renderValue={(selected) => (Array.isArray(selected) ? selected.join(', ') : '')}
            sx={{
              fontSize: '13px'
            }}>
            {accountantsList?.map((email) => (
              <MenuItem key={email} value={email}>
                <Checkbox checked={docAssignees?.includes(email)} />
                <ListItemText primary={email} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: 2 }}>
        <Btn
          text="Assign"
          width="7rem"
          color={Colors.WHITE}
          onClick={assignDocument}
          height="2.5rem"
          backgroundColor={Colors.DEEPBLUE}
          radius="10px"
          loading={isLoading}
          disabled={isEmpty(docAssignees) || isLoading}
          disabledColor={Colors.NAV_BLACK}
        />
      </Box>
    </Box>
  );
};

export default AssignDoc;
